






import Component from 'vue-class-component';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { FormContainer } from '@/common/mixin/FormContainer';
import { ModelFormModel } from '@/context/model/model/ModelFormModel';
import ModelForm from '@/context/model/component/ModelForm.vue';
import { ModelApi } from '@/context/model/api/ModelApi';

@Component({
  components: {
    ModelForm,
    FormBase
  }
})
export default class ModelFormContainer extends FormContainer<ModelFormModel> {
  model: ModelFormModel = new ModelFormModel();

  async formApi(): Promise<ModelFormModel> {
    return await ModelApi.instance().form<ModelFormModel>(
      ModelFormModel,
      this.$route?.params?.id ? { id: this.$route.params.id } : null
    );
  }
}
